module.exports = __webpack_public_path__ + "img/bjx_d_7.e9252edc.png";